import { render, staticRenderFns } from "./disclosure.vue?vue&type=template&id=5224fa8b&scoped=true&"
import script from "./disclosure.vue?vue&type=script&lang=js&"
export * from "./disclosure.vue?vue&type=script&lang=js&"
import style0 from "./disclosure.vue?vue&type=style&index=0&id=5224fa8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224fa8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VApp,VCard,VDivider,VListItemTitle})
